import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from 'vue'
import { Check, Close } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CrudDialog',
  props: {
    modelValue: { type: Boolean },
    title: {},
    submit: {},
    width: { default: 'min(520px, calc(100vw - 32px))' },
    confirmText: { default: '确认' },
    cancelText: { default: '取消' },
    destroyOnClose: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "success", "submit-error", "cancel", "closed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const submitting = ref(false)
const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value)
})

const handleCancel = () => {
  if (submitting.value) return
  emit('cancel')
  visible.value = false
}

const handleConfirm = async () => {
  if (submitting.value) return
  submitting.value = true

  try {
    const success = await props.submit()
    if (!success) return
    emit('success')
    visible.value = false
  } catch (error) {
    emit('submit-error', error)
  } finally {
    submitting.value = false
  }
}

const handleBeforeClose = (done: () => void) => {
  if (!submitting.value) done()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: _ctx.title,
    width: _ctx.width,
    "destroy-on-close": _ctx.destroyOnClose,
    "close-on-click-modal": false,
    "close-on-press-escape": !submitting.value,
    "show-close": !submitting.value,
    "before-close": handleBeforeClose,
    onClosed: _cache[1] || (_cache[1] = ($event: any) => (emit('closed')))
  }, {
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer", {
        submitting: submitting.value,
        confirm: handleConfirm,
        cancel: handleCancel
      }, () => [
        _createVNode(_component_el_button, {
          disabled: submitting.value,
          onClick: handleCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Close), {
              class: "crud-dialog__icon",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.cancelText), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: submitting.value,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [
            (!submitting.value)
              ? (_openBlock(), _createBlock(_unref(Check), {
                  key: 0,
                  class: "crud-dialog__icon",
                  "aria-hidden": "true"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.confirmText), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", { submitting: submitting.value })
    ]),
    _: 3
  }, 8, ["modelValue", "title", "width", "destroy-on-close", "close-on-press-escape", "show-close"]))
}
}

})